import { useState } from 'react';
//@ts-ignore
import { db, storage } from "../../utils/firebase"; // Import Firebase Firestore & Storage
import { doc, updateDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { ToastContainer, toast } from "react-toastify";

const UploadUserLogo = () => {
  const [formData, setFormData] = useState({
    email: '',
    logo: null,
  });

  const handleChange = (e: any) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === 'logo' ? files[0]: value,  
    }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    //console.log('Upload Logo Data Submitted:', formData);
    // Add your logo upload logic here
    if (!formData.email || !formData.logo) {
      toast.error("Email and logo are required!");
      return;
    }

    try {
      const logoRef = ref(storage, `logos/${formData.email}-${Date.now()}`);
      await uploadBytes(logoRef, formData.logo);
      const logoURL = await getDownloadURL(logoRef);
      //console.log('url', logoURL)
      // Update Firestore with the logo URL
      const userDocRef = doc(db, "userDetails", formData.email);
      await updateDoc(userDocRef, { logo: logoURL });

      toast.success("Logo uploaded successfully!");

      // Clear form
      setFormData({ email: "", logo: null });
    } catch (error) {
      console.error("Error uploading logo:", error);
      toast.error("Failed to upload logo.");
      setFormData({ email: "", logo: null });
    }
  };

  return (
    <div className="max-w-2xl bg-white rounded-lg shadow p-4 lg:p-6">
    <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

      <h2 className="text-xl font-bold mb-6">Upload User Logo</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Email */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
          />
        </div>

        {/* Upload Logo */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Upload Logo</label>
          <input
            type="file"
            name="logo"
            accept="image/*"
            onChange={handleChange}
            required
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
          />
        </div>

        {/* Submit Button */}
        <div>
          <button
            type="submit"
            className="w-full bg-[#0b3a28] text-white px-6 py-2 rounded-lg hover:bg-[#1c2822]"
          >
            Upload Logo
          </button>
        </div>
      </form>
    </div>
  );
};

export default UploadUserLogo;